import { render, staticRenderFns } from "./VipGoldenSpin.vue?vue&type=template&id=760edaaf&scoped=true&"
import script from "./VipGoldenSpin.vue?vue&type=script&lang=js&"
export * from "./VipGoldenSpin.vue?vue&type=script&lang=js&"
import style0 from "./VipGoldenSpin.vue?vue&type=style&index=0&lang=css&"
import style1 from "./VipGoldenSpin.vue?vue&type=style&index=1&id=760edaaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760edaaf",
  null
  
)

export default component.exports